import { ReactNode } from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Button, { Props as ButtonProps } from 'components/button/Button';
import useAppModal from 'hooks/useAppModal';
import useModalId from '../useModalId';

interface ModalFormCancelButtonProps extends Omit<ButtonProps, 'children'> {
  children?: ReactNode;
  'data-testid'?: string;
}

const ModalFormCancelButton = ({
  children,
  'data-testid': dataTestId,
  disabled,
  onClick,
  ...props
}: ModalFormCancelButtonProps) => {
  const { t } = useTranslation();
  const { closeModal } = useAppModal();
  const { isSubmitting } = useFormState();
  const modalId = useModalId();

  const handleOnClick: ButtonProps['onClick'] = (event) => {
    closeModal(modalId);
    onClick?.(event);
  };

  return (
    <Button
      data-testid={dataTestId ?? 'modal-form-cancel-button'}
      disabled={disabled ?? isSubmitting}
      onClick={handleOnClick}
      {...props}
    >
      {children ?? t('common.cancel')}
    </Button>
  );
};

ModalFormCancelButton.defaultProps = {
  children: undefined,
  'data-testid': undefined,
};

export default ModalFormCancelButton;
